import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

export interface DetailArrowButtonProps {
  row: Record<string, unknown>;
  detailHref: string;
  itemLabel: string;
  nodeId: number | undefined;
  onOpen?: (row: Record<string, unknown>) => void;
}

export const DetailArrowButton: React.FC<DetailArrowButtonProps> = ({
  row,
  detailHref,
  itemLabel,
  nodeId,
  onOpen,
}) => {
  const ariaLabel = nodeId == null ? `Open ${itemLabel}` : `Open ${itemLabel} ${nodeId}`;
  const arrow = (
    <Box component="span" sx={{ fontSize: 14, fontWeight: 700 }}>
      &rarr;
    </Box>
  );
  if (onOpen) {
    return (
      <IconButton
        size="small"
        onClick={(e: React.MouseEvent) => {
          e.stopPropagation();
          onOpen(row);
        }}
        aria-label={ariaLabel}
        sx={{ color: 'v4.accent' }}
      >
        {arrow}
      </IconButton>
    );
  }
  return (
    <IconButton
      component={RouterLink}
      to={detailHref}
      size="small"
      onClick={(e: React.MouseEvent) => e.stopPropagation()}
      aria-label={ariaLabel}
      sx={{ color: 'v4.accent' }}
    >
      {arrow}
    </IconButton>
  );
};
